import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const AuditLogListDetails = () => { 
  const [auditLogs, setAuditLogs] = useState([]); 
  
  useEffect(() => { 
    fetchAuditLogs(); 
  }, []); 
  
  const fetchAuditLogs = async () => { 
    try { 
      const url = `${API_DOMAIN}${API_ROUTES.audit_log}`; 
      const token = localStorage.getItem('token'); 
       
      const response = await axios.get(url, { headers }); 
      const auditLogsData = response.data.map((log) => {
        return { 
          ...log, 
          action_name: log.action === "CREATE" ? "Create" : 
                       log.action === "UPDATE" ? "Update" : 
                       log.action === "DELETE" ? "Delete" : "", 
        };
      });
      setAuditLogs(auditLogsData); 
    } catch (error) { 
      console.error('Error fetching audit logs:', error); 
    } 
  };
  
  const columns = [ 
    { label: 'Action', value: 'action_name' }, 
    { label: 'Model Name', value: 'model_name' }, 
    { label: 'Object ID', value: 'object_id' }, 
    { label: 'User', value: 'user' }, 
    { label: 'Timestamp', value: 'timestamp' }, 
  ]; 
  
  const handleViewDetails = (logId) => { 
    //console.log('View Details', logId); 
    window.location.href = `/audit-log/details/${logId}`; 
  }; 
  
  const handleEditDetails = (logId) => {
    const encodedId = btoa(logId); 
    window.location.href = `/audit-log/input/${encodedId}`;
  };
  
  const actionButtons = [ 
    { label: 'Edit Details', handler: handleEditDetails }, 
  ]; 
  
  return <ListTemplate columns={columns} data={auditLogs} actionButtons={actionButtons} />; 
}; 
  
export default AuditLogListDetails;